<template>
  <div class="hello">
    <div class="header">
      <div class="logo">
        <img src="../assets/img/logo.png" alt="">
      </div>
      <div class="text">保互通APP</div>
    </div>
    <div class="button" @click="down">
      <img :src="isIos ? iosimg : andimg " alt="">
      <span>{{isIos ? 'iphone安装' : 'Android安装' }}</span>
    </div>
    <div class="Line"></div>
    <div class="application">
      <div class="app_l">应用介绍</div>
      <div class="app_t">
        保互通(北京)有限公司(以下简称“保互通”)是由中国人保集团(PICC) 旗下中国人民人寿保险股份有限公司独家发起设立的全资子公司。作为服务人保系统内部的金融科技公司，保互通通过打造“综合视频+商城生态圈”，向中国人保提供多样化、定制化互联网服务，实现科技赋能，服务保险主业。
      </div>
    </div>
    <!-- <div class="time">
      <div class="edition">当前版本3.1.16</div>
      <div class="time_rq">2022年12月31日</div>
    </div> -->
    <div v-show="isWeChatflag" class="Mask">
      <div class="mask_text">
        <div class="p">1.点击右上角的···</div>
        <div class="p">2.然后点击<img class="img" :src="isIos ? iosliu : andliu" alt=""></div>
      </div>
      <img class="img_log" src="../assets/img/tuc.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  props: {

  },
  data(){
    return{
      isIos:false,
      iosimg:require('../assets/img/ios.png'),
      andimg:require('../assets/img/android.png'),
      iosliu:require('../assets/img/liulanqi.png'),
      andliu:require('../assets/img/liulanqi1.png'),
      isWeChatflag:false,
    }
  },
  created(){
    // console.log(this.isWeChat(),'created')
    if(this.myBrowser() == 'isIOS'){
      this.isIos = true
    }else{
      this.isIos = false
    }
    if(this.isWeChat()){
      this.isWeChatflag = true
    }else{
      this.isWeChatflag = false
    }
  },
  components: {
  
  },
  mounted(){
    // console.log(this.myBrowser(),'mounted')
  },
  methods: {
    down(){
      if(this.isIos){
        window.location.href ='https://apps.apple.com/cn/app/%E4%BF%9D%E4%BA%92%E9%80%9A/id1229991168'
      }else{
        window.location.href ='https://picc-file-oss.oss-cn-beijing.aliyuncs.com/prod/bht.apk'
      }
    },
    myBrowser() {
      // 获取浏览器 userAgent
      var ua = navigator.userAgent
      if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) return 'Android'
      var isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isIOS) return 'isIOS'
      return false
    },
    isWeChat(){
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger" || ua.match(/Alipay/i)=="alipay" || ua.match(/QQ/i) == "qq"){
        return true
      }else{
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.hello{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.header{
  width: 100%;
  height:699px;
  background:url('../assets/img/ban.png') center;
  background-size:cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 51px;
}
.logo{
  width:125px;
  height: 125px;
  margin-top: 126px;
  margin-bottom: 18px;
  img{
    width: 100%;
    height: 100%;
  }
}
.text{
  height: 27px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FA0000;
  line-height: 48px;
}
.button{
  width: 403px;
  height: 84px;
  background: #FB0000;
  border-radius: 38px;
  display: flex;
  align-items: center;
  margin-bottom: 33px;
  img{
    width: 36px;
    height: 36px;
    margin-left: 97px;
    margin-right: 21px;
  }
  span{
    display: block;
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFF9F9;
    text-align: center;
  }
}
.Line{
  width: 662px;
  height: 1px;
  background: #EEEEEE;
  border-radius: 1px;
  margin-bottom: 51px;
}
.application{
  width: 88%;
  // margin-bottom: 38px;
}
.app_l{
  height: 27px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 41px;
  margin-bottom: 35px;
}
.app_t{
  width: 100%;
  height: 231px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 41px;
  text-align: justify;
}
.time{
  position: absolute;
  bottom: -100px;
  right: 50px;
}
.edition,.time_rq{
  height: 40px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.Mask{
  width: 100%;
  min-height: 100vh;
  background: rgba(0, 0, 0, .6);
  position: fixed;
  top:0;
  left: 0;
}
.img_log{
    width: 88px;
    height: 107px;
    position: absolute;
    right: 88px;
    top: 37px;
  }
.mask_text{
  width: 562px;
  height: 224px;
  background: #FDFDFD;
  opacity: 0.96;
  border-radius: 20px;
  position: absolute;
  top: 186px;
  left:94px ;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .p{
    width: 80%;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .img{
      width: 57px;
      height:57px;
      margin-left: 20px;
    }
  }

}
</style>
